/* src/app/settings/pages/user-profile/user-profile.component.scss */
/*# sourceMappingURL=user-profile.component.css.map */
